import { sortBy } from 'lodash';
import { ReviewTemplate } from '../../../../../types';

const sortedReviewTemplates: ReviewTemplate[] = sortBy(
  [
    {
      template: 'Cancellation - Traditional, all items were scanned',
      appliesToTypes: ['Cancellation'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems', 'numUnpaidItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s, {kioskScannedItems} at the kiosk,
            canceled the transaction, and departed the market with {numUnpaidItems} unpaid item/s.
            No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Cancellation - Traditional, only some items were scanned',
      appliesToTypes: ['Cancellation'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numItemsOverlooked',
          label: 'Number of Items Overlooked',
          placeholder: '# overlooked',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems', 'numItemsOverlooked', 'numUnpaidItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s, {kioskScannedItems} at the kiosk
            while overlooking {numItemsOverlooked} item/s, canceled the transaction, and departed the market with
            {numUnpaidItems} unpaid item/s. No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Cancellation - Failed Payment',
      appliesToTypes: ['Cancellation'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numPaymentAttempts',
          label: 'Number of Payment Attempts',
          placeholder: '# attempts',
        },
        {
          type: 'text',
          formControlName: 'paymentMethod',
          label: 'Payment Method',
          placeholder: 'e.g. credit card, cash',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and {kioskScannedItems}
            at the kiosk.`,
        },
        {
          keys: ['numPaymentAttempts', 'paymentMethod'],
          template: `The individual attempted to pay {numPaymentAttempts} time(s) using {paymentMethod}, but the transaction failed.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `Then, the individual departed the market with {numUnpaidItems} unpaid item/s.
            No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Cancellation - Timeout',
      appliesToTypes: ['Cancellation'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and {kioskScannedItems} at
            the kiosk. The individual attempted to pay, but the payment was not completed.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The pending transaction timed out, and the individual departed the market with {numUnpaidItems} unpaid item/s.
            No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Cancellation - Proxy Cancel',
      appliesToTypes: ['Cancellation'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and {kioskScannedItems} at
            the kiosk. The individual attempted to pay, but the payment was not processed.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The individual departed the market with {numUnpaidItems} unpaid item/s, while another individual
            canceled the transaction. No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Cancellation and Underringing',
      appliesToTypes: ['Cancellation', 'Underringing'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'number',
          formControlName: 'numItemsScanned',
          label: 'Number of Items Re-Scanned',
          placeholder: '# re-scanned',
        },
        {
          type: 'number',
          formControlName: 'numPaidItems',
          label: 'Number of Paid Items',
          placeholder: '# paid',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items',
          placeholder: '# unpaid',
        },
        {
          type: 'number',
          formControlName: 'numTotalItems',
          label: 'Total Actual Items',
          placeholder: '# total',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'numItemsScanned'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s, scanned and canceled the
            transaction, then re-scanned {numItemsScanned} item/s and completed a purchase.`,
        },
        {
          keys: ['numPaidItems', 'numTotalItems'],
          template: `Only {numPaidItems} of {numTotalItems} item/s were paid for.`,
        },
        {
          keys: ['numPaidItems', 'numUnpaidItems'],
          template: `Per the transaction report, the individual departed the market with {numPaidItems} paid and
            {numUnpaidItems} unpaid item/s.`,
        },
      ],
    },
    {
      template: 'Cancellation - Null Transactions',
      appliesToTypes: ['Cancellation'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing'],
          template: `The individual wearing {describeClothing} entered the market area and interacted with the kiosk,
            but as per the transaction report, no transaction was completed.`,
        },
        {
          keys: ['numSnacksDrinksSelected', 'numUnpaidItems'],
          template: `The individual selected {numSnacksDrinksSelected} item/s and departed the market with {numUnpaidItems} unpaid
            item/s while the kiosk screen timed out. No payment was received for {numUnpaidItems} item/s.`,
        },
      ],
    },
    {
      template: 'Walkout - Traditional',
      appliesToTypes: ['Walkout'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and departed the market
            without any attempt to pay at the kiosk.`,
        },
      ],
    },
    {
      template: 'Underringing - Traditional',
      appliesToTypes: ['Underringing'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'number',
          formControlName: 'numItemsScanned',
          label: 'Number of Items Scanned',
          placeholder: '# scanned',
        },
        {
          type: 'number',
          formControlName: 'numPaidItems',
          label: 'Number of Paid Items Taken',
          placeholder: '# taken',
        },
        {
          type: 'number',
          formControlName: 'totalActualItemsObserved',
          label: 'Total Actual Items Observed in the Video',
          placeholder: '# observed',
        },
        {
          type: 'number',
          formControlName: 'numItemsOverlooked',
          label: 'Number of Items Overlooked',
          placeholder: '# overlooked',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s.`,
        },
        {
          keys: ['numItemsScanned'],
          template: `The individual only scanned {numItemsScanned} item/s at the kiosk and completed the transaction.`,
        },
        {
          keys: ['numPaidItems', 'totalActualItemsObserved'],
          template: `The individual only paid for {numPaidItems} out of {totalActualItemsObserved} item/s.`,
        },
        {
          keys: ['numPaidItems', 'numItemsOverlooked'],
          template: `The individual departed the market with {numPaidItems} paid item/s and {numItemsOverlooked} unpaid item/s.`,
        },
      ],
    },
    {
      template: 'Underringing - Extra Item',
      appliesToTypes: ['Underringing'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numItemsSelectedAfterTransaction',
          label: 'Number of Items Selected After Transaction',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskUnscannedItems',
          required: true,
          options: ['scanning it', 'scanning them'],
          label: 'Unscanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numPaidItems',
          label: 'Number of Paid Items Taken',
          placeholder: '# taken',
        },
        {
          type: 'number',
          formControlName: 'numItemsOverlooked',
          label: 'Number of Items Overlooked',
          placeholder: '# overlooked',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s, {kioskScannedItems} at
            the kiosk, and completed the transaction.`,
        },
        {
          keys: ['numItemsSelectedAfterTransaction', 'kioskUnscannedItems'],
          template: `Then the individual selected another/more {numItemsSelectedAfterTransaction} item(s) without
            {kioskUnscannedItems} at the kiosk.`,
        },
        {
          keys: ['numPaidItems', 'numItemsOverlooked'],
          template: `The individual departed the market with {numPaidItems} paid item/s and {numItemsOverlooked} unpaid item/s,
            per the transaction report.`,
        },
      ],
    },
    {
      template: 'Underringing - Fictitious Item Search Bar',
      appliesToTypes: ['Underringing'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'text',
          formControlName: 'costOfFalseItem',
          label: 'Cost of False Item Selected',
          placeholder: 'e.g. $12.50',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksRemoved',
          label: 'Number of Snacks/Drinks Removed',
          placeholder: '# removed',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# unpaid',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and approached the kiosk.
            At the kiosk, the individual utilized the "search" button on the kiosk to search for a different item.
            They selected the false item and completed the transaction.`,
        },
        {
          keys: ['costOfFalseItem'],
          template: `The cost of the false item selected was {costOfFalseItem}.`,
        },
        {
          keys: ['numSnacksDrinksRemoved'],
          template: `The appropriate payment for {numSnacksDrinksRemoved} item/s removed from the market was not received.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The individual departed the market with {numUnpaidItems} unpaid item/s.`,
        },
      ],
    },
    {
      template: 'Underringing - Lesser Priced Item',
      appliesToTypes: ['Underringing'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'text',
          formControlName: 'describeSnackDrink',
          label: 'Describe the Snack/Drink',
          placeholder: 'e.g. a bag of chips',
        },
        {
          type: 'text',
          formControlName: 'estimatedTotal',
          label: 'Total of Transaction',
          placeholder: 'e.g. $12.50',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksRemoved',
          label: 'Number of Snacks/Drinks Removed',
          placeholder: '# removed',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and approached the kiosk.`,
        },
        {
          keys: ['describeSnackDrink'],
          template: `At the kiosk, the individual scanned merchandise {describeSnackDrink} and completed the transaction.`,
        },
        {
          keys: ['estimatedTotal'],
          template: `The merchandise that the individual scanned cost {estimatedTotal}, which is less than what was
            removed from the market.`,
        },
        {
          keys: ['numSnacksDrinksRemoved'],
          template: `The appropriate payment for {numSnacksDrinksRemoved} item/s removed from the market was not received.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The individual departed the market with {numUnpaidItems} unpaid item/s.`,
        },
      ],
    },
    {
      template: 'Walkout - Pseudo-Cancellation',
      appliesToTypes: ['Walkout'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scanned it', 'scanned them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and {kioskScannedItems} at
            the kiosk. The individual attempted to pay, but the payment was not completed.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The pending transaction timed out and the individual departed the market with {numUnpaidItems} unpaid item/s.
            No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Walkout - Fake Scan',
      appliesToTypes: ['Walkout'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'select',
          formControlName: 'kioskScannedItems',
          required: true,
          options: ['scan it', 'scan them'],
          label: 'Scanned Item(s) at the Kiosk',
          placeholder: 'Select an option',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected', 'kioskScannedItems'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and attempted to
            {kioskScannedItems} at the kiosk, but nothing was scanned.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The individual departed the market with {numUnpaidItems} item/s. No payment was received per the transaction report.`,
        },
      ],
    },
    {
      template: 'Walkout - Playing with the Kiosk',
      appliesToTypes: ['Walkout'],
      fields: [
        {
          type: 'text',
          formControlName: 'describeClothing',
          label: "Describe the Individual's Clothing",
          placeholder: 'e.g. black shirt and red cap',
        },
        {
          type: 'number',
          formControlName: 'numSnacksDrinksSelected',
          label: 'Number of Snacks/Drinks Selected',
          placeholder: '# selected',
        },
        {
          type: 'number',
          formControlName: 'numUnpaidItems',
          label: 'Number of Unpaid Items Taken',
          placeholder: '# taken',
        },
      ],
      results: [
        {
          keys: ['describeClothing', 'numSnacksDrinksSelected'],
          template: `The individual wearing {describeClothing} selected {numSnacksDrinksSelected} item/s and interacted with the kiosk.`,
        },
        {
          keys: ['numUnpaidItems'],
          template: `The individual did not scan the item/s and then departed the market with {numUnpaidItems} item/s.
            No payment was received per the transaction report.`,
        },
      ],
    },
  ],
  'template',
);

export const templateFormFields: ReviewTemplate[] = [
  {
    template: 'None',
    fields: [],
    results: [],
    appliesToTypes: [],
  },

  ...sortedReviewTemplates,
];
